import React from 'react';
import styled from 'styled-components';
import { Alert, Typography } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
var StoppedMessageWrapper = styled.div.withConfig({
  displayName: "stop-messagecomponent__StoppedMessageWrapper",
  componentId: "sc-py5ak8-0"
})(["max-width:80%;.ant-alert{background-color:#fff2f0;border:1px solid #ffccc7;border-radius:8px;min-width:250px;.ant-alert-content{.ant-alert-message{color:#cf1322 !important;font-weight:600;font-size:14px;margin-bottom:4px;}.ant-alert-description{color:#595959 !important;font-size:13px;line-height:1.5;}}}"]);
export var StopMessage = function StopMessage() {
  return /*#__PURE__*/_jsx(StoppedMessageWrapper, {
    children: /*#__PURE__*/_jsx(Alert, {
      type: "warning",
      showIcon: false,
      message: /*#__PURE__*/_jsx(Typography.Text, {
        strong: true,
        style: {
          color: '#cf1322',
          fontSize: '14px'
        },
        children: "Generation Stopped"
      }),
      description: /*#__PURE__*/_jsx(Typography.Text, {
        style: {
          color: '#595959',
          fontSize: '13px',
          lineHeight: '1.5'
        },
        children: "You canceled this chat."
      })
    })
  });
};